if (!customElements.get('image-text-slider')) {
  customElements.define(
    'image-text-slider',
    class extends HTMLElement {
      connectedCallback() {
        if (typeof Swiper === 'undefined') {
          document.addEventListener('DOMContentLoaded', () => this.init());
          return;
        }
        this.init();
      }

      init() {
        const sliderWrap = this.closest('.image-text-slider__slider-wrap');
        const spaceBetween = parseInt(this.dataset.space || '12');
        const slidesDesktop = parseFloat(this.dataset.slidesDesktop || '3');
        const slidesMobile = parseFloat(this.dataset.slidesMobile || '1.15');
        const autoplayDelay = parseInt(this.dataset.autoplay || '0');

        const config = {
          slidesPerView: slidesMobile,
          spaceBetween,
          breakpoints: {
            749: {
              slidesPerView: slidesDesktop,
              spaceBetween
            }
          }
        };

        const pagination = sliderWrap?.querySelector('.swiper-pagination');
        if (pagination) config.pagination = { el: pagination, clickable: true };

        const scrollbar = sliderWrap?.querySelector('.swiper-scrollbar');
        if (scrollbar) config.scrollbar = { el: scrollbar, draggable: true };

        const prevEl = sliderWrap?.querySelector('.swiper-button-prev');
        const nextEl = sliderWrap?.querySelector('.swiper-button-next');
        if (prevEl && nextEl) config.navigation = { prevEl, nextEl };

        if (autoplayDelay > 0) {
          config.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          };
        }

        this._swiper = new Swiper(this, config);
      }
    }
  );
}
